import $ from 'jquery';

$(document).ready(function () {

  var fancyWrapper = $('.fancy-wrapper');
  fancyWrapper.each(function () {

    // strong && bold
    $(this).find('strong,b').addClass('font-semibold');

    // ul
    if (!($(this).hasClass("no-fancy-ul"))) {
      $(this).find('ul,ol').addClass('fancy').find('li');
    }

    // Htags
    $(this).find('h1, h2, h3, h4, h5, h6').addClass('title-wrapper title title-regular fs-regular mb-2');
    /*
    $(this).find('.table-flex').each(function () {
    var currentTable = $(this);
    var generatedElement = '<div class="d-flex flex-wrap table-flex-fancy align-items-center justify-content-around">';
    var nbElement = $(this).find('tr td').length;
    var maxWidth = Math.round(100/nbElement);
    $(this).find('tr td').each(function () {
    $(this).find("img").removeClass('lazyloading');
    $(this).find('*').addClass('text-center');
    $(this).wrapInner( "<div class='inner-table-flex d-flex flex-column justify-content-center align-items-center' style='max-width:"+maxWidth+"%'></div>" );
    var innerContent = $(this).html();
    generatedElement += innerContent;
  });
  generatedElement += "</div>";
  currentTable.after(generatedElement);
  currentTable.remove();
});
*/
});

$(".go-table-responsive").find('table').wrap('<div class="table-responsive"></div>').addClass('table table-striped');
});
